/* WJW 44: mobile-only launcher. No effect unless explicitly enabled in Theme Editor. */
(() => {
  if (window.__wjwPhotoLaunchInitialized) return;
  window.__wjwPhotoLaunchInitialized = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest && event.target.closest('[data-wjw-photo-launch]');
    if (!button || window.innerWidth >= 750 || button.dataset.wjwPhotoEnabled !== 'true') return;
    const path = button.dataset.wjwPhotoUrl || '/search?view=wjw-photo-search';
    if (!path.startsWith('/') || path.startsWith('//')) return;
    event.preventDefault();
    window.location.assign(path);
  });
})();
